<template>
  <b-container fluid>
    <template>
      <b-overlay :show="loadingPdf">
    <b-row>
      <b-col lg="12" sm="12">
        <iq-card>
          <template v-slot:body>
            <b-overlay v-if="unitLoad">
                <b-col xs="12" sm="12" md="12" class="text-right mt-4 mb-4" style="margin-left: -5px">
                    <b-button-group>
                        <b-button @click="pdfExport" variant="success"><i style="font-size: 18px; margin: 0; padding: 0;" class="ri-printer-fill"></i></b-button>
                      </b-button-group>
                </b-col>
                <b-row v-if="reportHeadData">
                    <b-col xs="12" sm="12" md="3" class="text-right mt-4">
                        <b-img :src="`${ reportHeadData.reportHeadColumn[0].image }`" fluid alt="BD Image" style="width:35%;border-radius:50%;"></b-img>
                    </b-col>
                    <b-col xs="12" sm="12" md="6" class="text-center mt-2">
                        <h3 class="text-bold">
                            {{ $t('production_store.govt_info') }}
                        </h3>
                        <h4 class="text-center text-dark">
                            {{ $t('social_service.dss') }}
                        </h4>
                        <!-- <span class="text-center text-dark">
                            {{ reportHeadData.heading }}
                        </span><br> -->
                        <span class="text-center text-dark">
                            {{ reportHeadData.address }}
                        </span><br>
                        <div class="titleDiv">
                            <span class="text-center text-dark reportTitle" style="font-weight:bold;">
                                {{ $t('report.financial_aid_report') }}
                            </span><br>
                        </div>
                    </b-col>
                    <b-col xs="12" sm="12" md="3" class="text-left mt-4">
                        <b-img :src="`${ reportHeadData.reportHeadColumn[1].image }`" fluid alt="BD Image" style="width:35%;border-radius:50%;"></b-img>
                    </b-col>

                </b-row>
                <b-row>
                    <b-col><br></b-col>
                </b-row>
            <!-- </b-overlay>
            <b-overlay :show="loadingState"> -->
              <b-row>
                <b-col md="12" class="table-responsive">
                  <b-table bordered hover :items="report_data" :fields="columns" aria-hidden="loading | listReload ? 'true' : null" :emptyText="$t('globalTrans.noDataFound')" show-empty>
                    <!-- <template v-slot:cell(index)="data">
                      {{ $n(data.index + pagination.slOffset) }}
                    </template> -->

                    <template v-slot:cell(sl_no_tarikh)="data">
                      <div>{{ $n(data.index + pagination.slOffset) }}</div>
                      <!-- <div>{{ data.item.delivery_date }}</div> -->
                      <div style="width: 80px">{{ data.item.delivery_date }}</div>
                    </template>

                    <template v-slot:cell(ward_bed_registration_num)="data">
                      <div>{{ data.item.hos_ward_id ? $n(data.item.hos_ward_id) : '-' }}</div>
                      <div>{{ data.item.hos_bed_id ? $n(data.item.hos_bed_id) : '-' }}</div>
                      <div>{{ data.item.hos_reg_no ? data.item.hos_reg_no : '-' }}</div>
                    </template>

                    <template v-slot:cell(patient_name_age_gender)="data">
                      <div>{{ currentLocale === 'en' ? data.item.patient_name : data.item.patient_name_bn }}</div>
                      <div>{{ data.item.age ? $n(data.item.age) : '-' }}</div>
                      <div>{{ currentLocale === 'en' ? data.item.gender_name_en : data.item.gender_name_bn }}</div>
                    </template>

                    <template v-slot:cell(address_mobile)="data">
                      <div>{{ currentLocale === 'en' ? data.item.address : data.item.address_bn }}</div>
                      <div>{{ data.item.phone_no }}</div>
                    </template>

                    <template v-slot:cell(money_amount)="data">
                      <div>{{ data.item.amount ? $n(data.item.amount) : $n(0) }}</div>
                    </template>
                  </b-table>
                  <b-pagination
                    v-model="pagination.currentPage"
                    :per-page="pagination.perPage"
                    :total-rows="pagination.totalRows"
                    @input="searchData"
                    />
                </b-col>
              </b-row>
            </b-overlay>
          </template>
        </iq-card>
      </b-col>
    </b-row>
    </b-overlay>
    </template>
  </b-container>
</template>
<script>

// import { ValidationObserver, ValidationProvider } from 'vee-validate'
import RestApi, { hospitalServiceBaseUrl } from '@/config/api_config'
import { financialAidReportApi } from '../../../api/routes'
import ReportHeading from '@/Utils/report-head'
import RouteBasedList from '@/mixins/route-base-list'
import Custom from '../../../../store/custom'
import ExportPdf from './export-pdf-details'

export default {
    mixins: [RouteBasedList],
    props: ['data'],
    emits: ['load'],
    data () {
      return {
        titleData: {
          month_name: null
        },
        /** */
        districtList: [],
        upazillaList: [],
        hospitalList: [],
        search: {
          division_id: 0,
          district_id: 0,
          upazilla_id: 0,
          hospital_id: 0,
          month_id: 0,
          year_id: 0
        },
        loadingReportHeadData: false,
        reportHeadData: null,
        report_data: [],
        unitLoad: false,
        loadingPdf: false,
        dataLoad: false
      }
    },
    computed: {
        columns () {
            const labels = [
                { label: this.$t('report.sl_no_tarikh'), class: 'text-left' },
                { label: this.$t('report.indoor_outdoor'), class: 'text-left' },
                { label: this.$t('report.patient_name_age_gender'), class: 'text-left' },
                { label: this.$t('report.ward_bed_registration_num'), class: 'text-left' },
                { label: this.$t('report.address_mobile'), class: 'text-left' },
                { label: this.$t('report.disease_name'), class: 'text-left' },
                { label: this.$t('report.recommender_doctor_name_department'), class: 'text-left' },
                { label: this.$t('report.service_type'), class: 'text-left' },
                { label: this.$t('report.money_amount'), class: 'text-left' },
                // { label: this.$t('report.receiver_signature'), class: 'text-left' },
                // { label: this.$t('report.deliverer_signature'), class: 'text-left' },
                { label: this.$t('report.officer_signature'), class: 'text-left' },
                { label: this.$t('social_service.comment'), class: 'text-left' }
            ]

            let keys = []

            if (this.$i18n.locale === 'bn') {
                keys = [
                  { key: 'sl_no_tarikh' },
                  { key: 'admission_type_name_bn' },
                  { key: 'patient_name_age_gender' },
                  { key: 'ward_bed_registration_num' },
                  { key: 'address_mobile' },
                  { key: 'patient_situation_bn' },
                  { key: 'doctor_name_bn' },
                  { key: 'sub_service_type_name_bn' },
                  { key: 'money_amount' },
                  // { key: 'receiver_signature' },
                  // { key: 'deliverer_signature' },
                  { key: 'officer_signature' },
                  { key: 'comment' }
                ]
            } else {
                keys = [
                  { key: 'sl_no_tarikh' },
                  { key: 'admission_type_name_en' },
                  { key: 'patient_name_age_gender' },
                  { key: 'ward_bed_registration_num' },
                  { key: 'address_mobile' },
                  { key: 'patient_situation' },
                  { key: 'doctor_name' },
                  { key: 'sub_service_type_name_en' },
                  { key: 'money_amount' },
                  // { key: 'receiver_signature' },
                  // { key: 'deliverer_signature' },
                  { key: 'officer_signature' },
                  { key: 'comment' }
                ]
            }

            return labels.map((item, index) => {
                return Object.assign(item, keys[index])
            })
        },
        currentLocale () {
          return this.$i18n.locale
        },
        divisionList: function () {
          return this.$store.state.commonObj.divisionList.filter(item => item.status === 0)
        },
        yearList: function () {
          const data = this.$store.state.commonObj.fiscalYearList.filter(item => item.status === 0)
          const years = data.map((obj, key) => {
            // const year = obj.text.split('-')[0]
            const year = obj.text
            // const year = obj.text
            return { value: obj.text_en.split('-')[1], text: year }
          })
          // Getting the last year on the end of the Fiscal Year List
          // const lastYear = (data[data.length - 1].text.split('-')[1])
          // years.push({ value: lastYear, text: lastYear })
          return years
        },
        monthList () {
          const objectData = this.$store.state.commonObj.monthList
          return objectData.map((obj, key) => {
            if (this.$i18n.locale === 'bn') {
              return { value: obj.value, text: obj.text_bn }
            } else {
              return { value: obj.value, text: obj.text_en }
            }
          })
        }
    },
    watch: {
      /** Used to get month name in title data */
      'search.month_id': function (newVal, oldVal) {
        if (newVal !== oldVal) {
         this.titleData.month_name = this.getMonthName(newVal)
       }
      },
      'search.division_id': function (newVal, oldVal) {
        this.search.district_id = 0
        this.districtList = this.getDistrictList(newVal)
      },
      'search.district_id': function (newVal, oldVal) {
        this.search.upazilla_id = 0
        this.upazillaList = this.getupazillaList(newVal)
      },
      'search.upazilla_id': function (newVal, oldVal) {
        // Reset both hospital id & list
        this.search.hospital_id = 0
        if (newVal !== 0) {
          this.hospitalList = this.getHospitalListByUpazillaId(newVal)
        } else if (newVal === 0) {
          this.hospitalList = this.getHospitalListAll()
        }
      }
    },
    created () {
      if (this.data) {
        this.loadData()
      }
        this.headerName()
        // this.loadData() // To serve as an example
        this.hospitalList = this.getHospitalListAll()
        this.unitLoad = false
    },
    methods: {
        getDistrictList (divisionId = null) {
          return this.$store.state.commonObj.districtList.filter(item => item.status === 0 && item.division_id === divisionId)
        },
        getupazillaList (districtId = null) {
          return this.$store.state.commonObj.upazilaList.filter(item => item.status === 0 && item.district_id === districtId)
        },
        getHospitalListByUpazillaId: function (upazillaId = null) {
          return this.$store.state.HospitalDisabilityService.commonObj.hospitalInfoList.filter(item => item.status === 1 && item.upazilla_id === upazillaId)
        },
        getHospitalListAll: function () {
          return this.$store.state.HospitalDisabilityService.commonObj.hospitalInfoList.filter(item => item.status === 1)
        },
        getMonthName (mId = null) {
          const monthId = parseInt(mId)
          const objectData = this.monthList.find(month => month.value === monthId)
          return objectData !== undefined ? objectData.text : null
        },
        searchData () {
          this.loadData()
        },
        // Header Data
        async headerName () {
            this.loadingReportHeadData = true
            const result = await ReportHeading.getReportHead(hospitalServiceBaseUrl, 'configuration/report-heading/detail', 3)
            this.reportHeadData = result
            this.loadingReportHeadData = false
        },
        // --- Load ---
        loadData () {
          this.dataLoad = true
          const params = Object.assign({}, this.data, { page: this.pagination.currentPage, per_page: this.pagination.perPage })
          this.$store.dispatch('mutateCommonProperties', { loading: true, listReload: false })
          RestApi.getData(hospitalServiceBaseUrl, financialAidReportApi, params).then(response => {
              if (response.success) {
                  this.unitLoad = true
                  this.dataLoad = false
                  this.report_data = this.getRelationalData(response.data.data)
                  this.$store.dispatch('setList', (response.data.data))
                  this.paginationData(response.data)
                  this.$emit('load', 1)
              }
              this.$store.dispatch('mutateCommonProperties', { loading: false, listReload: false })
          })
        },
        // Relational Data
        getRelationalData (data) {
          const listData = data.map(item => {
            // Relational
            const tmpAdmissionType = Custom.admissionTypeList.find(admissionType => admissionType.id === item.admission_type)
            const tmpGenderType = this.$store.state.commonObj.genderList.find(gender => gender.value === item.gender_id)
            const tmpSubServiceType = Custom.subServiceTypeList.find(subServiceType => subServiceType.value === item.sub_service_type_id)

            // Evaluate
            const evaluationData = {
              admission_type_name_bn: tmpAdmissionType !== undefined ? tmpAdmissionType.name_bn : '',
              admission_type_name_en: tmpAdmissionType !== undefined ? tmpAdmissionType.name : '',
              gender_name_bn: tmpGenderType !== undefined ? tmpGenderType.text_bn : '',
              gender_name_en: tmpGenderType !== undefined ? tmpGenderType.text_en : '',
              sub_service_type_name_bn: tmpSubServiceType !== undefined ? tmpSubServiceType.text_bn : '',
              sub_service_type_name_en: tmpSubServiceType !== undefined ? tmpSubServiceType.text_en : ''
            }

            // Assign
            return Object.assign({}, item, evaluationData)
          })
          return listData
        },
        pdfExport () {
          this.loadingPdf = true
          const reportTitle = this.$t('report.financial_aid_report')
          const data = JSON.parse(JSON.stringify(this.report_data))
          ExportPdf.exportPdfDetails(hospitalServiceBaseUrl, 'configuration/report-heading/detail', 3, reportTitle, data, this, this.titleData)
          this.loadingPdf = false
      }
    }
}
</script>
<style lang="scss">
  .titleDiv {
    font-size: 18px;
  }
  .details_report {
    font-size: 8px;
    color: #000;
    h5 {
      color: green !important;
      font-size: 12px !important;
    }
    .table-bordered td:nth-child(2n+1) {
      font-weight: 700;
    }
    .table-bordered th {
      text-align: center;
      font-size: 11px !important;
      // font-weight: 900 !important;
    }
    .table-bordered tr td {
      font-size: 9px !important;
      text-align: center;
    }
  }
  .hidden_header {
    display: none
  }
  .card-border {
    border: 1px solid #b9bdc1;
    box-shadow: 1px 1px 6px -1px grey;
    background-color: #dee2e6;
  }
  [dir=ltr][mode=light] .card-body {
    flex: 1 1 auto;
    min-height: 1px;
    padding: 10px;
  }
</style>
